const dayFmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin' }); // YYYY-MM-DD

export interface Line {
  order_pos_no: number;
  article_code: string;
  article_name: string;
  expected_delivery_quantity: number;
  confirmed_delivery_quantity: number | null;
  is_narcotic: boolean;
}

export interface Tote {
  package_id: string;
  package_type: string;
  csc_order_no: number;
  delivery_advice_no: number;
  tracking_barcode: string | null;
  tote_deleted_at: string | null;
  line_details: Line[];
}

export interface Tour {
  tour_id: string;
  delivered_at: string | null;
  planned_time_of_arrival: string;
  expected_time_of_arrival_min: string | null;
  expected_time_of_arrival_max: string | null;
  delay_in_minutes: number | null;
  delay_information: string | null;
  package: Tote[];
}

export interface TourResponse {
  tour_information: { tour: Tour[] };
}

export interface TourDocument {
  no: number;
  label: string;
  lines: Line[];
}

export const dayString = (daysBack = 0): string => {
  const d = new Date();
  d.setDate(d.getDate() - daysBack);
  return dayFmt.format(d);
};

export const isNightTour = (tourId: string): boolean => Number(tourId.slice(0, 2)) >= 24;

export function sortChronological(tours: Tour[]): Tour[] {
  return [...tours.filter(t => isNightTour(t.tour_id)), ...tours.filter(t => !isNightTour(t.tour_id))];
}

export function groupDocuments(totes: Tote[]): TourDocument[] {
  const active = totes.filter(t => t.tote_deleted_at === null);
  const map = new Map<number, Line[]>();
  for (const tote of active) {
    const lines = map.get(tote.delivery_advice_no) ?? [];
    lines.push(...tote.line_details);
    map.set(tote.delivery_advice_no, lines);
  }
  return [...map].map(([no, lines]) => ({
    no,
    label: 'Beleg zur Sammelrechnung',
    lines: lines.sort((a, b) => a.order_pos_no - b.order_pos_no),
  }));
}

export function parseTourId(tourId: string, daysBack: number) {
  const hours = Number(tourId.slice(0, 2));
  const shift = Math.floor(hours / 24);
  const date = new Date();
  date.setDate(date.getDate() - daysBack - shift);
  return {
    time: `${String(hours - shift * 24).padStart(2, '0')}:${tourId.slice(2, 4)}`,
    suffix: tourId.slice(4),
    date,
  };
}
